export default class LocalConfig {
    static getConfig(jsonFile = '/localConfig.json') {
        let res = {};
        let xhr = new XMLHttpRequest();
        xhr.open('GET', jsonFile, false);

        try {
            xhr.send();
            if (xhr.status == 200) {
                res = JSON.parse(xhr.response);
            }
        } catch (err) { // instead of onerror
        }
        return res;
    }
    static getValue(key, defValue, jsonFile = '/localConfig.json') {
        let res = defValue;
        const config = LocalConfig.getConfig(jsonFile);
        try {
            res = config[key] || defValue;
        }
        catch {
        }
        return res;
    }
}